import React, { useEffect, useState, useContext } from "react";
import { Tabs, Tab, PageContent, Page, PageHeader, Box, Text, DataTable, Select, Spinner, Button, Layer, Form, FormField, TextInput, Heading, Card, CardBody, Header, MaskedInput, CheckBox, ResponsiveContext, Data, Toolbar, DataSearch, DataFilters, DataTableColumns, DataSummary } from 'grommet';
import { useSelector, useDispatch } from "react-redux";
import { Edit, Link, StatusGoodSmall, StatusUnknownSmall, Trash, Close, } from "grommet-icons";
import { storageAdminService } from "../services";
import { NotificationContext } from "../components/admin/NotificationContext";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { storageAdminActions } from "../redux/actions/storageAdminActions";
import { storageService } from "../services/storage";


const exportToExcel = (inData, fileName) => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    let input = [];
    inData.forEach(element => {
        input.push(element);
    });
    const ws = XLSX.utils.json_to_sheet(input);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};

export const StorageAdminDataManager = () => {
    const { id } = useParams()
    const session = useSelector((state) => {
        return state.session;
    });
    const TabContent = ({ ...rest }) => (
        <Box pad={{ vertical: 'medium' }}>
            <Box background="background-front" pad="medium" round="medium" {...rest} />
        </Box>
    );
    const [applicationName, setApplicationName] = useState('');
    useEffect(() => {
        if (session) {
            const appDetails = storageService.getApplicationById(session.user.access, id)
            appDetails.then((response) => {
                setApplicationName(response.application_name)
            })
        }
    }, [session, applicationName, id])
    return <>

        <Page>
            <PageContent>
                {applicationName === '' ? <Spinner /> : <PageHeader title={applicationName + "\t Data Manager"} />}
                <Box>
                    <Tabs justify="start">
                        <Tab title="Application Primaries">
                            <TabContent>
                                <ApplicationPrimaries application_id={id} />
                            </TabContent>
                        </Tab>
                        <Tab title="Application Secondaries">
                            <TabContent>
                                <ApplicationSecondaries application_id={id} />
                            </TabContent>
                        </Tab>
                    </Tabs>
                </Box>
            </PageContent>
        </Page>
    </>
}

export const ApplicationPrimaries = ({ application_id }) => {
    const dispatch = useDispatch();
    const session = useSelector((state) => {
        return state.session;
    });

    useEffect(() => {
        if (session && session.user && session.user.access) {
            dispatch(storageAdminActions.getPrimariesForApplication(session.user.access, application_id))
        }
        // if (session && session.user && session.user.access) {
        //     dispatch(adminActions.getAllCompetitorProducts(session.user.access));
        //     dispatch(adminActions.getAllProductTypes(session.user.access));
        // }
    }, [session, dispatch, application_id]);
    const primaryList = useSelector((state) => {
        return state.storageAdminDataManager.storage_admin_primaries
    })

    const size = useContext(ResponsiveContext);
    const { showNotification } = useContext(NotificationContext)
    const [updateFormValues, setUpdateFormValues] = useState({
        'primary_name': '',
        'order': 0,
        'primary_application_group': 0,
        'primary_description': '',
        'is_enabled': true
    })
    const [onUpdateClicked, setOnUpdateClicked] = useState(false)
    const [onUpdateClickedId, setOnUpdateClickedId] = useState(null)
    const onUpdateChanged = values => {
        setUpdateFormValues(values)
    }
    const onUpdateSubmit = ({ value, touched }) => {
        let formData = new FormData()
        Object.entries(value).forEach(([key, value]) => {
            formData.append(key, value)
        })
        formData.set('primary_application_group', application_id)
        try {
            storageAdminService.updatePrimary(session.user.access, onUpdateClickedId, formData)
            showNotification('Application Primary updated succefully updated', 'normal')
        } catch (e) {
            showNotification("Error while updating primary details. \n Error: " + e.toString(), 'critical')
        } finally {
            setOnUpdateClicked(false)
        }
    }
    const [onDeleteClicked, setOnDeleteClicked] = useState(false)
    const [onDeleteClickedId, setOnDeleteClickedId] = useState(null)
    const onDeleteSubmit = ({ value, touched }) => {
        try {
            storageAdminService.deletePrimary(session.user.access, onDeleteClickedId)
            showNotification('Primary deleted successfully', 'normal')
        } catch (error) {
            showNotification('Primary deleted faied with error: \n ' + error.toString(), 'normal')
        } finally {
            setOnDeleteClicked(false)
        }
    }
    const [addFormValues, setAddFormValues] = useState({
        'primary_name': '',
        'order': 0,
        'primary_application_group': 0,
        'primary_description': '',
        'is_enabled': true
    })
    const [onAddClicked, setOnAddClicked] = useState(false)
    const onAddChanged = values => {
        setAddFormValues(values)
    }
    const onAddSubmit = ({ value, touched }) => {
        const formData = new FormData()
        Object.entries(value).forEach(([key, value]) => {
            formData.append(key, value)
        })
        formData.set('primary_application_group', application_id)
        try {
            storageAdminService.addPrimary(session.user.access, formData).then((response) => {
                console.log({ response })
            })
            showNotification('Competitor product succefully added', 'normal')
        } catch (error) {
            showNotification("Error while updating competitor product details. \n Error: " + error.toString(), 'critical')
        } finally {
            setOnAddClicked(false)
        }
    }
    const properties = {
        'primary_application_group': { label: 'Primary' },
    }
    const columns = [
        { property: 'id', header: 'Id', size: "small", primary: true },
        {
            property: 'primary_name',
            header: 'Name',
            size: 'small',
            render: datum => <Text key={datum.primary_name}>{datum.primary_name}</Text>
        },
        {
            property: 'primary_description',
            header: 'Description',
            size: 'small',
            render: datum => <Text key={datum.primary_description}>{datum.primary_description}</Text>
        },
        {
            property: 'order',
            header: 'Order',
            size: 'small',
            render: datum => <Text key={datum.order}>{datum.order}</Text>
        },
        {
            property: 'is_enabled',
            header: 'Enabled',
            size: 'small',
            render: datum => datum.is_enabled ? <><StatusGoodSmall color="status-ok" /></> : <><StatusUnknownSmall color="status-unknown" />
            </>
        },
        {
            property: 'created_at',
            header: 'Created Date',
            size: 'small',
            render: datum => <Text key={datum.created_at}>{datum.created_at}</Text>
        },
        {
            property: 'updated_at',
            header: 'Updated Date',
            size: 'small',
            render: datum => <Text key={datum.updated_at}>{datum.updated_at}</Text>
        },
        {
            size: 'xxsmall',
            render: dataum =>
                <>
                    <Box direction="row">
                        <Button icon={<Edit />} onClick={() => {
                            setOnUpdateClickedId(dataum.id)
                            setUpdateFormValues(
                                {
                                    'primary_name': dataum.primary_name,
                                    'primary_application_group': application_id,
                                    'primary_description': dataum.primary_description ? dataum.primary_description : "",
                                    'is_enabled': dataum.is_enabled,
                                    'order': dataum.order
                                })
                            setOnUpdateClicked(true)
                        }} />
                    </Box>
                </>
        },
        {
            size: 'xxsmall',
            render: dataum =>
                <>
                    <Box direction="row">
                        <Button icon={<Trash />} onClick={() => {
                            setOnDeleteClicked(true)
                            setOnDeleteClickedId(dataum.id)
                        }} />
                    </Box>
                </>
        }
    ]
    const options = columns.filter(({ header }) => header).map(({ header, property }) => ({
        property,
        label: header
    }))
    const [selected, setSelected] = useState([]);
    const maskForJustWords = [
        {
            regexp: /^[a-zA-Z0-9 -]+$/,
            placeholder: ' example-1',
        },
    ];
    const maskForJustNumbers = [
        {
            regexp: /^[0-9]+$/,
            placeholder: 'example',
        },
    ];
    const PrimaryTableResults = () => {
        return (
            <Box flex overflow="auto">
                <DataTable
                    aria-describedby="servers-heading"
                    columns={[
                        ...columns,
                    ]}
                    pin
                    primaryKey="id"
                    sortable
                    onSelect={nextSelected => setSelected([...nextSelected])}
                    select={selected}
                />
            </Box>
        );
    }
    const [cancel, setCancel] = React.useState('');
    const confirmDelete = () => {
        const doesMatch = cancel.delete === 'DELETE';
        return doesMatch
            ? undefined
            : { message: 'Text does not match "DELETE"', status: 'error' };
    };
    return <>
        {primaryList.requestInProgress ? <Spinner /> : primaryList.data ? <>
            <Data data={primaryList.data} properties={properties}>
                <Toolbar>
                    <Toolbar>
                        <DataSearch responsive />
                        <DataFilters drop />
                        <DataTableColumns drop tip="Configure Columns" options={options} />
                    </Toolbar>
                    <Box flex />
                    <Button label="Export" onClick={() => {
                        var selectedPrimaries;
                        if (selected) {
                            selectedPrimaries = primaryList.data.filter((item) => selected.indexOf(item.id) !== -1)
                        }
                        else {
                            selectedPrimaries = primaryList.data
                        }
                        exportToExcel(selectedPrimaries, "Primaries")
                    }} />
                    <Button secondary label="Add Primary" onClick={() => {
                        setOnAddClicked(true)
                    }} />

                </Toolbar>
                <DataSummary />
                <PrimaryTableResults />
            </Data>
        </> : <Text>No data found!</Text>
        }
        {
            <>
                {onUpdateClicked && <Layer onClickOutside={() => {
                    setOnUpdateClicked(false)
                }} onEsc={() => { setOnUpdateClicked(false) }}>
                    <Box pad="medium">
                        <Box direction="row" align="start" gap="small">
                            <Box gap="medium">
                                <Heading level={2} margin="none">
                                    Primary Update
                                </Heading>
                                <Form
                                    validate="blur"
                                    value={updateFormValues}
                                    messages={{ required: 'This is a required field.' }}
                                    onChange={nextValue => onUpdateChanged(nextValue)}
                                    onSubmit={({ value, touched }) => onUpdateSubmit({ value, touched })}
                                    method="post"
                                >
                                    <FormField
                                        label="Name"
                                        htmlFor="primary-name"
                                        name="primary_name"
                                        required
                                    >
                                        <MaskedInput id="primary_name" name="primary_name" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Description"
                                        htmlFor="primary-description"
                                        name="primary_description"
                                        required
                                    >
                                        <MaskedInput id="primary_description" name="primary_description" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Order"
                                        htmlFor="order-for-primary"
                                        name="order"
                                        required
                                    >
                                        <MaskedInput id="order-for-primary" name="order" mask={maskForJustNumbers} />
                                    </FormField>
                                    <FormField
                                        label="Is Enabled ?"
                                        htmlFor="is-company-enabled"
                                        name="is_enabled"
                                    >
                                        <CheckBox toggle id="is-company-enabled" name="is_enabled" label="Is Enabled ?" />
                                    </FormField>
                                    <Box
                                        align={!['xsmall', 'small'].includes(size) ? 'start' : undefined}
                                        margin={{ top: 'medium', bottom: 'small' }}
                                    >
                                        <Button label={"Update"} primary type="submit" />
                                    </Box>
                                </Form>
                            </Box>
                            <Button
                                icon={<Close />}
                                onClick={() => {
                                    setOnUpdateClicked(false)
                                }}
                                a11yTitle={`You are in a layer containing a properties of competitors to update.`}
                                autoFocus
                            />
                        </Box>
                    </Box>
                </Layer>}
            </>
        }
        {
            <>
                {onAddClicked && <Layer onClickOutside={() => {
                    setOnAddClicked(false)
                }} onEsc={() => { setOnAddClicked(false) }}>
                    <Box pad="medium">
                        <Box direction="row" align="start" gap="small">
                            <Box gap="medium">
                                <Heading level={2} margin="none">
                                    Add New Primary
                                </Heading>
                                <Form
                                    validate="blur"
                                    value={addFormValues}
                                    messages={{ required: 'This is a required field.' }}
                                    onChange={nextValue => onAddChanged(nextValue)}
                                    onSubmit={({ value, touched }) => onAddSubmit({ value, touched })}
                                    method="post"
                                >
                                    <FormField
                                        label="Name"
                                        htmlFor="primary-name"
                                        name="primary_name"
                                        required
                                    >
                                        <MaskedInput id="primary_name" name="primary_name" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Description"
                                        htmlFor="primary-description"
                                        name="primary_description"
                                        required
                                    >
                                        <MaskedInput id="primary_description" name="primary_description" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Order"
                                        htmlFor="order-for-primary"
                                        name="order"
                                        required
                                    >
                                        <MaskedInput id="order-for-primary" name="order" mask={maskForJustNumbers} />
                                    </FormField>
                                    <FormField
                                        label="Is Enabled ?"
                                        htmlFor="is-company-enabled"
                                        name="is_enabled"
                                    >
                                        <CheckBox toggle id="is-company-enabled" name="is_enabled" label="Is Enabled ?" />
                                    </FormField>
                                    <Box
                                        align={!['xsmall', 'small'].includes(size) ? 'start' : undefined}
                                        margin={{ top: 'medium', bottom: 'small' }}
                                    >
                                        <Button label="Add" primary type="submit" />
                                    </Box>
                                </Form>
                            </Box>
                            <Button
                                icon={<Close />}
                                onClick={() => {
                                    setOnAddClicked(false)
                                }}
                                a11yTitle={`You are in a layer containing a properties of competitors to update.`}
                                autoFocus
                            />
                        </Box>
                    </Box>
                </Layer>}
            </>
        }
        {onDeleteClicked && <Layer onClickOutside={() => {
            setOnDeleteClicked(false)
        }} onEsc={() => {
            setOnDeleteClicked(false)
        }}>
            <Card width="medium">
                <CardBody gap="medium">
                    <Header
                        direction="column"
                        align="start"
                        gap="xxsmall"
                        pad={{ horizontal: 'xxsmall' }}
                    >
                        <Heading level={2} margin="none">
                            Delete Primary
                        </Heading>
                    </Header>
                    <Text>
                        Are you sure you want to delete this primary? Doing so will erase all related
                        the data(including its resources).
                    </Text>
                    <Box
                        // Padding used to prevent focus from being cutoff
                        pad={{ horizontal: 'xxsmall' }}
                    >
                        <Form
                            validate="blur"
                            onChange={setCancel}
                            messages={{
                                required: 'This is a required field.',
                            }}
                            onSubmit={({ value, touched }) => onDeleteSubmit({ value, touched })}
                        >
                            <FormField
                                label="Type DELETE to verify"
                                name="delete"
                                htmlFor="delete"
                                required
                                validate={confirmDelete}
                            >
                                <TextInput id="delete" name="delete" placeholder="DELETE" />
                            </FormField>
                            <Box
                                justify="end"
                                gap="medium"
                                margin={{ top: 'medium', bottom: 'small' }}
                                direction="row"
                            >
                                <Button label="Cancel" onClick={() => { setOnDeleteClicked(false) }} />
                                <Button label="Delete Primary" primary type="submit" />
                            </Box>
                        </Form>
                    </Box>
                </CardBody>
            </Card>
        </Layer>}
    </>
}

export const ApplicationSecondaries = ({ application_id }) => {
    const dispatch = useDispatch();
    const session = useSelector((state) => {
        return state.session;
    });
    useEffect(() => {
        if (session && session.user && session.user.access) {
            dispatch(storageAdminActions.getSecondoriesForApplication(session.user.access, application_id))
        }
        // if (session && session.user && session.user.access) {
        //     dispatch(storageAdminActions.getSecondoriesForApplication(session.user.access, application_id))
        // }
    }, [session, dispatch, application_id]);

    const secondaryList = useSelector((state) => {
        return state.storageAdminDataManager.storage_admin_secondaries
    })
    const primaryList = useSelector((state) => {
        return state.storageAdminDataManager.storage_admin_primaries
    })
    const [onUpdateClicked, setOnUpdateClicked] = useState(false)
    const [onAddClicked, setOnAddClicked] = useState(false)
    const [onDeleteClicked, setOnDeleteClicked] = useState(false)
    const [updateFormValues, setUpdateFormValues] = useState({
        "name": "",
        "link": "",
        "is_enabled": true,
        "order": 0,
        "level2_primary_group": 0,
        "description": "",
    })
    const [addFormValues, setAddFormValues] = useState({
        "name": "",
        "link": "",
        "is_enabled": true,
        "order": 0,
        "level2_primary_group": 0,
        "description": "",
    })
    const onUpdateFormValuesChanged = values => {
        setUpdateFormValues(values)
    }
    const onAddFormValuesChanged = values => {
        setAddFormValues(values)
    }
    const maskForJustWords = [
        {
            regexp: /^[a-zA-Z0-9 -]+$/,
            placeholder: 'example-123',
        },
    ];

    const maskForJustNumbers = [
        {
            regexp: /^[0-9]+$/,
            placeholder: 'example',
        },
    ];
    const [primaryOptions, setPrimaryOptions] = useState([])

    const [updateSelectedId, setUpdateSelectedId] = useState(0)

    const [onDeleteClickedId, setOnDeleteClickedId] = useState(null)

    const [cancel, setCancel] = useState('');
    const confirmDelete = () => {
        const doesMatch = cancel.delete === 'DELETE';
        return doesMatch
            ? undefined
            : { message: 'Text does not match "DELETE"', status: 'error' };
    };
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (primaryList.data) {
            let opt = primaryList.data.map(item => ({
                label: item.primary_name,
                value: item.id
            }))
            setPrimaryOptions(opt)
        }
    }, [primaryList])

    const onUpdateSubmit = ({ value, touched }) => {
        let formData = new FormData()
        Object.entries(value).forEach(([key, value]) => {
            formData.append(key, value)
        })
        try {
            storageAdminService.updateLevel2ForPrimary(session.user.access, updateSelectedId, formData)
            showNotification('Application Secondary updated succefully', 'normal')
        } catch (error) {
            showNotification("Error while updating secondary details. \n Error: " + error.toString(), 'critical')
        }
        finally {
            setOnUpdateClicked(false)
        }
    }

    const onAddSubmit = ({ value, touched }) => {
        let formData = new FormData()
        Object.entries(value).forEach(([key, value]) => {
            formData.append(key, value)
        })
        try {
            storageAdminService.addLevel2ForPrimary(session.user.access, formData)
            showNotification('Application Secondary added succefully', 'normal')
        } catch (error) {
            showNotification("Error while updating secondary details. \n Error: " + error.toString(), 'critical')
        }
        finally {
            setOnAddClicked(false)
        }
    }

    const onDeleteSubmit = ({ value, touched }) => {
        try {
            storageAdminService.deleteLevel2ForPrimary(session.user.access, onDeleteClickedId)
            showNotification('Secondary deleted successfully', 'normal')
        } catch (error) {
            showNotification('Secondary delete failed with an error: \n ' + error.toString(), 'warning')
        } finally {
            setOnDeleteClicked(false)
        }
    }

    const columns = [
        { property: 'id', header: 'Id', size: "xsmall", primary: true },
        {
            property: 'name',
            header: 'Name',
            size: 'small',
            render: datum => <Text key={datum.name}>{datum.name}</Text>
        },
        {
            property: 'level2_primary_group',
            header: 'Primary',
            size: 'small',
            render: datum => <Text key={datum.level2_primary_group}>{datum.level2_primary_group}</Text>
        },
        {
            property: 'description',
            header: 'Description',
            size: 'small',
            render: datum => <Text key={datum.description}>{datum.description}</Text>
        },
        {
            property: 'order',
            header: 'Order',
            size: 'xsmall',
            render: datum => <Text key={datum.order}>{datum.order}</Text>
        },
        {
            property: 'updated_at',
            header: 'Updated Date',
            size: 'small',
            render: datum => <Text key={datum.updated_at}>{datum.updated_at}</Text>
        },
        {
            property: 'link',
            header: 'Link',
            size: 'xsmall',
            render: datum => <Button icon={<Link />} onClick={() => {
                window.open(datum.link)
            }} />
            // render: datum => <Text key={datum.resource_content_type}>{datum.resource_content_type}</Text>
        },
        {
            property: 'created_at',
            header: 'Created Date',
            size: 'small',
            render: datum => <Text key={datum.created_at}>{datum.created_at}</Text>
        },
        {
            size: 'xxsmall',
            render: dataum =>
                <>
                    <Box direction="row">
                        <Button icon={<Edit />} onClick={() => {
                            setUpdateSelectedId(dataum.id)
                            const primaryMatch = primaryList.data.find(primary => primary.primary_name === dataum.level2_primary_group)
                            if (primaryMatch) {
                                setUpdateFormValues({
                                    "name": dataum.name,
                                    "link": dataum.link,
                                    "is_enabled": dataum.is_enabled,
                                    "order": dataum.order,
                                    "level2_primary_group": primaryMatch.id,
                                    "description": dataum.description ? dataum.description : "",
                                })
                            }
                            setOnUpdateClicked(true)

                        }} />
                    </Box>
                </>
        },
        {
            size: 'xxsmall',
            render: dataum =>
                <>
                    <Box direction="row">
                        <Button icon={<Trash />} onClick={() => {
                            setOnDeleteClicked(true)
                            setOnDeleteClickedId(dataum.id)
                        }} />
                    </Box>
                </>
        }
    ]
    const options = columns.filter(({ header }) => header).map(({ header, property }) => ({
        property,
        label: header
    }))
    const properties = {
        'primary': { label: 'Primary' },
        'is_enabled': { label: "Is Enabled ?" },
    }
    const size = useContext(ResponsiveContext);
    const { showNotification } = useContext(NotificationContext)
    const SecondaryTableResults = () => {
        return (
            <Box flex overflow="auto">
                <DataTable
                    aria-describedby="servers-heading"
                    columns={[
                        ...columns,
                    ]}
                    pin
                    primaryKey="id"
                    sortable
                    onSelect={nextSelected => setSelected(nextSelected)}
                    select={selected}
                />
            </Box>
        );
    }
    const filterProps = {
        is_enabled: {
            label: "Is Enabled?",
            options: [
                { label: 'Active', value: true },
                { label: 'Inactive', value: false }
            ],
            filter: { control: "CheckBoxGroup" }
        },
        // you can add more filterable fields here
    };
    const normalizeDefaults = (properties) =>
        Object.keys(properties).reduce((acc, key) => {
            acc[key] = []; // always an array so .includes works
            return acc;
        }, {});
    return <>
        {/* {resourcesList.requestInProgress ? <Spinner /> : <DataTable columns={columns} data={resourcesList ? resourcesList.data : null} sort={{ ...sort }} fill gap="small" />} */}
        {secondaryList.requestInProgress ? <Spinner /> : secondaryList.data ? <>
            <Data data={secondaryList.data} properties={properties}>
                <Toolbar>
                    <Toolbar>
                        <DataSearch responsive />
                        <DataFilters
                            drop
                            properties={[filterProps]}
                            defaultValues={normalizeDefaults(filterProps)}
                        />
                        <DataTableColumns drop tip="Configure Columns" options={options} />
                    </Toolbar>
                    <Box flex />
                    <Button label="Export" onClick={() => {
                        var selectedSecondaries;
                        if (selected) {
                            selectedSecondaries = secondaryList.data.filter((item) => selected.indexOf(item.id) !== -1)
                        }
                        else {
                            selectedSecondaries = secondaryList.data
                        }
                        exportToExcel(selectedSecondaries, "Secondaries")
                    }} />
                    <Button secondary label="Add Secondary" onClick={() => {
                        setOnAddClicked(true)
                    }} />

                </Toolbar>
                <DataSummary />
                <SecondaryTableResults />
            </Data>
        </> : <Text> No resources found</Text>}
        {
            <>
                {onUpdateClicked && <Layer onClickOutside={() => {
                    setOnUpdateClicked(false)
                }} onEsc={() => { setOnUpdateClicked(false) }}>
                    <Box pad="medium">
                        <Box direction="row" align="start" gap="small">
                            <Box gap="medium">
                                <Heading level={2} margin="none">
                                    Secondary Update
                                </Heading>
                                <Form
                                    validate="blur"
                                    value={updateFormValues}
                                    messages={{ required: 'This is a required field.' }}
                                    onChange={nextValue => onUpdateFormValuesChanged(nextValue)}
                                    onSubmit={({ value, touched }) => onUpdateSubmit({ value, touched })}
                                    method="post"
                                >
                                    <FormField
                                        label="Title"
                                        htmlFor="name"
                                        name="name"
                                        required
                                    >
                                        <MaskedInput id="name" name="name" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Description"
                                        htmlFor="description"
                                        name="description"
                                        required
                                    >
                                        <MaskedInput id="description" name="description" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Order"
                                        htmlFor="order"
                                        name="order"
                                        required
                                    >
                                        <MaskedInput id="order" name="order" mask={maskForJustNumbers} />
                                    </FormField>
                                    <FormField label="Primary Group" name="level2_primary_group">
                                        <Select id="level2_primary_group" name='level2_primary_group'
                                            options={primaryOptions ? primaryOptions : []}
                                            labelKey={'label'}
                                            valueKey={{ 'key': 'value', reduce: true }}
                                            value={updateFormValues.level2_primary_group}
                                            onChange={({ option }) => {
                                                setUpdateFormValues(prev => ({ ...prev, level2_primary_group: option.value }))
                                            }}
                                        />
                                    </FormField>
                                    <FormField
                                        label="Link"
                                        htmlFor="resource-link"
                                        name="link"
                                        required
                                    >
                                        <MaskedInput id="link" name="link" />
                                    </FormField>
                                    <Box
                                        align={!['xsmall', 'small'].includes(size) ? 'start' : undefined}
                                        margin={{ top: 'medium', bottom: 'small' }}
                                    >
                                        <Button label={"Update"} primary type="submit" />
                                    </Box>
                                </Form>
                            </Box>
                            <Button
                                icon={<Close />}
                                onClick={() => {
                                    setOnUpdateClicked(false)
                                }}
                                a11yTitle={`You are in a layer containing a properties of competitors to update.`}
                                autoFocus
                            />
                        </Box>
                    </Box>
                    <>
                    </>
                </Layer>}
            </>
        }
        {
            <>
                {onAddClicked && <Layer onClickOutside={() => {
                    setOnAddClicked(false)
                }} onEsc={() => { setOnAddClicked(false) }}>
                    <Box pad="medium">
                        <Box direction="row" align="start" gap="small">
                            <Box gap="medium">
                                <Heading level={2} margin="none">
                                    Secondary Add
                                </Heading>
                                <Form
                                    validate="blur"
                                    value={addFormValues}
                                    messages={{ required: 'This is a required field.' }}
                                    onChange={nextValue => onAddFormValuesChanged(nextValue)}
                                    onSubmit={({ value, touched }) => onAddSubmit({ value, touched })}
                                    method="post"
                                >
                                    <FormField
                                        label="Title"
                                        htmlFor="name"
                                        name="name"
                                        required
                                    >
                                        <MaskedInput id="name" name="name" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Description"
                                        htmlFor="description"
                                        name="description"
                                        required
                                    >
                                        <MaskedInput id="description" name="description" mask={maskForJustWords} />
                                    </FormField>
                                    <FormField
                                        label="Order"
                                        htmlFor="order"
                                        name="order"
                                        required
                                    >
                                        <MaskedInput id="order" name="order" mask={maskForJustNumbers} />
                                    </FormField>
                                    <FormField label="Primary Group" name="level2_primary_group">
                                        <Select id="level2_primary_group" name='level2_primary_group'
                                            options={primaryOptions ? primaryOptions : []}
                                            labelKey={'label'}
                                            valueKey={{ 'key': 'value', reduce: true }}
                                            value={addFormValues.level2_primary_group}
                                            onChange={({ option }) => {
                                                setAddFormValues(prev => ({ ...prev, level2_primary_group: option.value }))
                                            }}
                                        />
                                    </FormField>
                                    <FormField
                                        label="Link"
                                        htmlFor="resource-link"
                                        name="link"
                                        required
                                    >
                                        <MaskedInput id="link" name="link" />
                                    </FormField>
                                    <Box
                                        align={!['xsmall', 'small'].includes(size) ? 'start' : undefined}
                                        margin={{ top: 'medium', bottom: 'small' }}
                                    >
                                        <Button label={"Add"} primary type="submit" />
                                    </Box>
                                </Form>
                            </Box>
                            <Button
                                icon={<Close />}
                                onClick={() => {
                                    setOnAddClicked(false)
                                }}
                                a11yTitle={`You are in a layer containing a properties of secondary values to add.`}
                                autoFocus
                            />
                        </Box>
                    </Box>
                    <>
                    </>
                </Layer>}
            </>
        }
        {onDeleteClicked && <Layer onClickOutside={() => {
            setOnDeleteClicked(false)
        }} onEsc={() => {
            setOnDeleteClicked(false)
        }}>
            <Card width="medium">
                <CardBody gap="medium">
                    <Header
                        direction="column"
                        align="start"
                        gap="xxsmall"
                        pad={{ horizontal: 'xxsmall' }}
                    >
                        <Heading level={2} margin="none">
                            Delete Resource
                        </Heading>
                    </Header>
                    <Text>
                        Are you sure you want to delete this Resource?
                    </Text>
                    <Box
                        // Padding used to prevent focus from being cutoff
                        pad={{ horizontal: 'xxsmall' }}
                    >
                        <Form
                            validate="blur"
                            onChange={setCancel}
                            messages={{
                                required: 'This is a required field.',
                            }}
                            onSubmit={({ value, touched }) => onDeleteSubmit({ value, touched })}
                        >
                            <FormField
                                label="Type DELETE to verify"
                                name="delete"
                                htmlFor="delete"
                                required
                                validate={confirmDelete}
                            >
                                <TextInput id="delete" name="delete" placeholder="DELETE" />
                            </FormField>
                            <Box
                                justify="end"
                                gap="medium"
                                margin={{ top: 'medium', bottom: 'small' }}
                                direction="row"
                            >
                                <Button label="Cancel" onClick={() => { setOnDeleteClicked(false) }} />
                                <Button label="Delete Secondary" primary type="submit" />
                            </Box>
                        </Form>
                    </Box>
                </CardBody>
            </Card>
        </Layer>}
    </>
}
